import api from './url'
import type { ReportDetailResponse, ReportListResponse } from './model/reportType'

import { jwtClientAxios } from '.'

export const getMyReportsApi = async (): Promise<ReportListResponse> => {
  try {
    const response = await jwtClientAxios().get(api.report.GET_MY_REPORTS)
    return response.data.data
  } catch (error) {
    console.error('상담 일지 조회 실패:', error)
    throw error
  }
}

export const getReportDetailApi = async (report_id: number): Promise<ReportDetailResponse> => {
  try {
    const response = await jwtClientAxios().get(api.report.GET_REPORT_DETAIL(report_id))
    return response.data.data
  } catch (error) {
    console.error('상담 일지 상세 조회 실패:', error)
    throw error
  }
}

export const deleteReportApi = async (report_id: number): Promise<void> => {
  try {
    const response = await jwtClientAxios().delete(api.report.DELETE_REPORT(report_id))
    return response.data
  } catch (error) {
    console.error('상담 일지 삭제 실패:', error)
    throw error
  }
}

export const getLastMindsetApi = async (): Promise<string> => {
  try {
    const response = await jwtClientAxios().get(api.report.GET_LAST_MINDSET())
    return response.data.data
  } catch (error) {
    console.error('최근 마음 상태 조회 실패:', error)
    throw error
  }
}
